__turbopack_context__.v({
  "active": "UserInfo-module__D-sCQa__active",
  "arrow": "UserInfo-module__D-sCQa__arrow",
  "caret": "UserInfo-module__D-sCQa__caret",
  "dropdownMenu": "UserInfo-module__D-sCQa__dropdownMenu",
  "icon": "UserInfo-module__D-sCQa__icon",
  "image": "UserInfo-module__D-sCQa__image",
  "label": "UserInfo-module__D-sCQa__label",
  "link": "UserInfo-module__D-sCQa__link",
  "login": "UserInfo-module__D-sCQa__login",
  "loginLink": "UserInfo-module__D-sCQa__loginLink",
  "trigger": "UserInfo-module__D-sCQa__trigger",
});
